<template>
  <div class="scroll-container">
    <!-- <vue-seamless-scroll :data="dataList" class="seamless-warp" :class-option="classOption" @ScrollEnd="ScrollEnd" ref="seamlessScroll"> -->
    <vue-seamless-scroll :data="dataList" class="seamless-warp" :class-option="classOption" ref="seamlessScroll">
        <slot name="list"></slot> 
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
    props:{
        dataList:{
            type:Array,
            default:[]
        },
        type:{
            type:String,
        }
    },
    computed:{
        classOption(){
            return {
                step: .3, // 数值越大速度滚动越快
                limitMoveNum:this.dataList.length, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                // waitTime: 0 // 单步运动停止的时间(默认值1000ms) 
            }
        }
    },
    components:{
        vueSeamlessScroll
    }, 
    data(){
        return{ 
            getOne:false,
            getRecOne:false,
            runHeight:'',
            str:'',
            timer:null,
            timer1:null,
            timer2:null,
            realnumData:[],
            realnumLength:0, 
        }
    },  
    watch: {
        str(newval) {
            // 45 我的每一行高度为45 可以自己定义其它数值 
            if (newval >= 45 && this.getOne) { 
                this.$emit('getMore') 
                this.getOne = false  // 避免计时请求重复 （因为不能特别准确的拿到str）
                clearInterval(this.timer) // 清除定时器
            } else if(newval >= 45 && this.getRecOne){
                this.$emit('getMoreRec') 
                this.getRecOne = false;// 避免重开计时器 
                clearInterval(this.timer) // 清除定时器
            }
        },
    },
    created(){ 
        if(this.type == 'pro-list'){ //项目滚动 
            if(this.timer1){
                clearInterval(this.timer1);
                this.timer1 = null;
            }
            let i = 0;
            this.timer1 = setInterval(()=>{ 
                i++;
                if(i>=38){
                    i=0; 
                    this.$emit('getMore');   
                }
            },1000)
        } else if(this.type == 'rec-list'){ //近期服务 
            if(this.timer2){
                clearInterval(this.timer2);
                this.timer2 = null;
            }
            let j = 0;
            this.timer2 = setInterval(()=>{ 
                j++; 
                if(j>=39){
                    j=0; 
                    this.$emit('getMoreRec') 
                    setTimeout(()=>{
                        this.$refs.seamlessScroll.reset();
                    },2000) 
                }
            },1000)
        }
    },
    methods:{ 
        // 计时器  
        getHeightTime() {
            this.runHeight = document.querySelector('.seamless-warp').children[0];  // 滚动的元素 table-warp是自定义的类名 
            this.timer = setInterval(() => {
                this.str = this.runHeight.style.transform.substr(16);
                this.str = this.str.substr(0, this.str.length - 3).split('.')[0] * 1 // 只需要数值部分   
            }, 50);
        }, 
        ScrollEnd() {  
            if(this.type == 'pro-list'){ 
                this.getOne = true;// 避免重开计时器
                this.getHeightTime(); // 计算实时滚动请求
            } else if(this.type == 'rec-list'){ 
                this.getRecOne = true;// 避免重开计时器
                this.getHeightTime(); // 计算实时滚动请求
            }
        }, 
    },
    destroyed(){ 
        if(this.timer){
            clearInterval(this.timer);
            this.timer = null;
        }
        if(this.timer1){
            clearInterval(this.timer1);
            this.timer1 = null;
        }
        if(this.timer2){
            clearInterval(this.timer2);
            this.timer2 = null;
        }
    }
}
</script>

<style lang="scss" scoped>
.scroll-container{ 
        // height: 25rem;
        height: 100%; 
        overflow: hidden;
    .seamless-warp{
        // height: 100%; 
        // overflow: hidden;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -ms-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-perspective: 1000;
        -moz-perspective: 1000;
        -ms-perspective: 1000;
        perspective: 1000; /* Other transform properties here */ 
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Scroll.vue